'use strict';

module.exports = require('./Switch');


/*****************
 ** WEBPACK FOOTER
 ** ./~/_rc-switch@1.4.4@rc-switch/lib/index.js
 ** module id = 631
 ** module chunks = 0 1
 **/